import React, { useEffect, useState } from 'react'
import { Button } from '@carbon/react' // Carbon Button
import {
  Microphone,
  StopFilledAlt,
  CloseFilled,
  PlayFilled,
  StopFilled,
  PauseOutlineFilled,
  TrashCan
} from '@carbon/icons-react' // Carbon Icons
import useAudioRecorder from '../utils/useAudioRecorder'
import { ConfirmPopup } from './ConfirmPopup'
import {
  DONE_CONFIRMATION,
  RECORD_CONFIRMATION,
  RECORD_DELETE
} from '../constants'

const AudioRecorderUI = ({
  initialAudioURL,
  onAudioURLChange,
  getRecordingStatus,
  isPreview,
  Completed,
  isActive,
  isClassroom,
  isAudioPlaying
}) => {
  const {
    isRecording,
    audioURL,
    recordingTime,
    playbackTime,
    isPlaying,
    isPaused,
    isUploading,
    startRecording,
    stopRecording,
    cancelRecording,
    uploadRecording,
    deleteRecording,
    playRecording,
    pausePlayback,
    stopPlayback
  } = useAudioRecorder(initialAudioURL)

  const [popupType, setPopupType] = useState('')
  const [confirmPopupVisible, setConfirmPopupVisible] = useState(false)

  // const audioURL = 'sample'
  // const isPlaying = true

  useEffect(() => {
    getRecordingStatus(isRecording)
  }, [isRecording])

  // Update the parent whenever the audioURL changes
  const handleStopRecording = async () => {
    const audioBlob = await stopRecording()
    const uploadedURL = await uploadRecording(audioBlob)
    onAudioURLChange(uploadedURL) // Notify the parent of the new audio URL
  }

  const handleDelete = async () => {
    await deleteRecording()
    onAudioURLChange(null) // Notify the parent of deletion
  }

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60)
      .toString()
      .padStart(2, '0')
    const seconds = Math.floor(time % 60)
      .toString()
      .padStart(2, '0')
    return `${minutes}:${seconds}`
  }

  function renderConfirmPopup() {
    return (
      <div>
        <ConfirmPopup
          popupType={popupType}
          popupVisible={confirmPopupVisible}
          popupText={
            popupType === 'recordSave' ? RECORD_CONFIRMATION : RECORD_DELETE
          }
          onPopupCancel={() => {
            setPopupType('')
            setConfirmPopupVisible(false)
            if (popupType === 'recordSave') {
            } else if (popupType === 'recordDelete') {
            }
          }}
          onPopupOk={() => {
            if (popupType === 'recordSave') {
              // setShowHideLoader(true)
              // setPopupType('')
              // setConfirmPopupVisible(false)
              // setRecordPopupClick('recordSave')
            } else if (popupType === 'recordDelete') {
              setPopupType('')
              setConfirmPopupVisible(false)
              handleDelete()
            }
          }}
        ></ConfirmPopup>
      </div>
    )
  }

  return (
    <div
      className='recording-cont'
      style={{
        border: !isRecording && !audioURL ? 'none' : '1px solid #4a22fe'
      }}
    >
      {!isRecording && !audioURL ? (
        <Button
          className='temp-button3-style'
          hasIconOnly
          iconDescription={'Record Audio'}
          renderIcon={Microphone}
          tooltipAlignment='center'
          tooltipPosition='bottom'
          disabled={
            isPreview
              ? true
              : isClassroom
              ? Completed === 1
                ? false
                : true
              : Completed === 1 || !isActive || isAudioPlaying
              ? true
              : false
          }
          onClick={() => {
            startRecording()
          }}
        />
      ) : (
        <div className='record-items-cont'>
          {!audioURL ? (
            <div className='record-items-cont'>
              <Button
                className='temp-button3-style recording-stop-icon'
                hasIconOnly
                iconDescription={'Stop Recording'}
                renderIcon={StopFilledAlt}
                tooltipAlignment='center'
                tooltipPosition='bottom'
                //  disabled={disableClick ? true : false}
                onClick={handleStopRecording}
              />
              <span className='record-timer-text'>
                {formatTime(recordingTime)}
              </span>
              <div className='record-child-cont'>
                <Button
                  className='record-child-icon'
                  hasIconOnly
                  iconDescription={'Cancel Recording'}
                  renderIcon={CloseFilled}
                  tooltipAlignment='center'
                  tooltipPosition='bottom'
                  //  disabled={disableClick ? true : false}
                  onClick={() => {
                    cancelRecording()
                  }}
                />
              </div>
            </div>
          ) : (
            <div className='record-items-cont'>
              <Button
                className='temp-button3-style'
                hasIconOnly
                iconDescription={isPlaying ? 'Stop Audio' : 'Play Audio'}
                renderIcon={isPlaying ? StopFilled : PlayFilled}
                tooltipAlignment='center'
                tooltipPosition='bottom'
                //  disabled={disableClick ? true : false}
                onClick={() => {
                  if (isPlaying) {
                    stopPlayback()
                  } else {
                    playRecording()
                  }
                }}
              />
              <span className='record-timer-text'>
                {formatTime(playbackTime)}
              </span>
              <div className='record-child-cont'>
                <Button
                  className='record-child-icon'
                  hasIconOnly
                  iconDescription={isPlaying ? 'Pause' : 'Play'}
                  renderIcon={isPlaying ? PauseOutlineFilled : PlayFilled}
                  tooltipAlignment='center'
                  tooltipPosition='bottom'
                  //  disabled={disableClick ? true : false}
                  onClick={() => {
                    if (isPlaying) {
                      pausePlayback()
                    } else {
                      playRecording()
                    }
                  }}
                />
                <Button
                  className='record-child-icon'
                  hasIconOnly
                  iconDescription={'Delete Audio'}
                  renderIcon={TrashCan}
                  tooltipAlignment='center'
                  tooltipPosition='bottom'
                  //  disabled={disableClick ? true : false}
                  onClick={() => {
                    setPopupType('recordDelete')
                    setConfirmPopupVisible(true)
                  }}
                />
              </div>
            </div>
          )}
          {/* <Button
            kind='danger--ghost'
            size='sm'
            renderIcon={Stop} // Render Stop Icon
            iconDescription='Stop Recording'
            onClick={stopRecording}
          />
          <Button
            kind='tertiary'
            size='sm'
            renderIcon={Close} // Render Close Icon
            iconDescription='Cancel Recording'
            onClick={stopRecording} // Treat cancel as stop in this case
          /> */}
        </div>
      )}
      {/* {audioURL && (
        <div style={{ marginTop: '16px' }}>
          <h3>Playback</h3>
          <audio src={audioURL} controls />
          <Button
            kind='primary'
            size='sm'
            renderIcon={Play} // Render Play Icon
            iconDescription='Play Recording'
            onClick={playRecording}
          >
            Play Recording
          </Button>
        </div>
      )} */}
      {renderConfirmPopup()}
    </div>
  )
}

export default AudioRecorderUI
